import axios from 'axios'

const api = axios.create({
  baseURL: '/tracer',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

export function apiPostManualVehicleTest({ payload }) {
  return api.post('/vehicletests', payload).then((resp) => resp.data)
}
